import { requestWithToken } from '../utilities/request';
const path = '/api/private/company_user_invitation_statuses';

const index = params => {
  return requestWithToken({
    method: 'GET',
    url: path,
    params,
  });
};

const update = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${id}`,
    data: param,
  });
};

export const CompanyUserInvitationStatusService = {
  index,
  update,
};
export default CompanyUserInvitationStatusService;



// WEBPACK FOOTER //
// ./src/services/CompanyUserInvitationStatuses.js